var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _circle78, _circle79, _circle80, _circle81, _circle82, _circle83, _circle84, _circle85, _circle86, _circle87, _circle88, _circle89, _circle90, _circle91, _circle92, _circle93, _circle94, _circle95, _circle96, _circle97, _circle98, _circle99, _circle100, _circle101, _circle102, _circle103, _circle104;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStars4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1152,
    height: 700,
    viewBox: "0 0 1152 700",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 330,
    cy: 290,
    r: 1,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 912,
    cy: 80,
    r: 1,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 283,
    cy: 66,
    r: 1,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 904,
    cy: 411,
    r: 1,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 642,
    cy: 201,
    r: 1,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 508,
    r: 1,
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 615,
    cy: 505,
    r: 1,
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 548,
    cy: 38,
    r: 1,
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 343,
    cy: 323,
    r: 1,
    fill: "white"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 925,
    cy: 113,
    r: 1,
    fill: "white"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 296,
    cy: 99,
    r: 1,
    fill: "white"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 917,
    cy: 444,
    r: 1,
    fill: "white"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 655,
    cy: 234,
    r: 1,
    fill: "white"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 269,
    cy: 541,
    r: 1,
    fill: "white"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 628,
    cy: 538,
    r: 1,
    fill: "white"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 561,
    cy: 71,
    r: 1,
    fill: "white"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 376,
    cy: 374,
    r: 1,
    fill: "white"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 958,
    cy: 164,
    r: 1,
    fill: "white"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 329,
    cy: 150,
    r: 1,
    fill: "white"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 950,
    cy: 495,
    r: 1,
    fill: "white"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 688,
    cy: 285,
    r: 1,
    fill: "white"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 302,
    cy: 592,
    r: 1,
    fill: "white"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 661,
    cy: 589,
    r: 1,
    fill: "white"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 594,
    cy: 122,
    r: 1,
    fill: "white"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 364,
    cy: 289,
    r: 1,
    fill: "white"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 946,
    cy: 79,
    r: 1,
    fill: "white"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 317,
    cy: 65,
    r: 1,
    fill: "white"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 938,
    cy: 410,
    r: 1,
    fill: "white"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 676,
    cy: 200,
    r: 1,
    fill: "white"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 290,
    cy: 507,
    r: 1,
    fill: "white"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 649,
    cy: 504,
    r: 1,
    fill: "white"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 582,
    cy: 37,
    r: 1,
    fill: "white"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 417,
    r: 1,
    fill: "white"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 774,
    cy: 207,
    r: 1,
    fill: "white"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 145,
    cy: 193,
    r: 1,
    fill: "white"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 766,
    cy: 538,
    r: 1,
    fill: "white"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 504,
    cy: 328,
    r: 1,
    fill: "white"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 635,
    r: 1,
    fill: "white"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 477,
    cy: 632,
    r: 1,
    fill: "white"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 410,
    cy: 165,
    r: 1,
    fill: "white"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 444,
    cy: 378,
    r: 1,
    fill: "white"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 1026,
    cy: 168,
    r: 1,
    fill: "white"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 397,
    cy: 154,
    r: 1,
    fill: "white"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 1018,
    cy: 499,
    r: 1,
    fill: "white"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 756,
    cy: 289,
    r: 1,
    fill: "white"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 370,
    cy: 596,
    r: 1,
    fill: "white"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 729,
    cy: 593,
    r: 1,
    fill: "white"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 662,
    cy: 126,
    r: 1,
    fill: "white"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 293,
    r: 1,
    fill: "white"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 714,
    cy: 83,
    r: 1,
    fill: "white"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 69,
    r: 1,
    fill: "white"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 706,
    cy: 414,
    r: 1,
    fill: "white"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 444,
    cy: 204,
    r: 1,
    fill: "white"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 511,
    r: 1,
    fill: "white"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 417,
    cy: 508,
    r: 1,
    fill: "white"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 41,
    r: 1,
    fill: "white"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 380,
    r: 1,
    fill: "white"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 1032,
    cy: 170,
    r: 1,
    fill: "white"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 403,
    cy: 156,
    r: 1,
    fill: "white"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 1024,
    cy: 501,
    r: 1,
    fill: "white"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 762,
    cy: 291,
    r: 1,
    fill: "white"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 376,
    cy: 598,
    r: 1,
    fill: "white"
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: 735,
    cy: 595,
    r: 1,
    fill: "white"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: 668,
    cy: 128,
    r: 1,
    fill: "white"
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: 238,
    cy: 325,
    r: 1,
    fill: "white"
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: 820,
    cy: 115,
    r: 1,
    fill: "white"
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: 191,
    cy: 101,
    r: 1,
    fill: "white"
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: 812,
    cy: 446,
    r: 1,
    fill: "white"
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: 550,
    cy: 236,
    r: 1,
    fill: "white"
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: 164,
    cy: 543,
    r: 1,
    fill: "white"
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: 523,
    cy: 540,
    r: 1,
    fill: "white"
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    cx: 456,
    cy: 73,
    r: 1,
    fill: "white"
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    cx: 403,
    cy: 365,
    r: 1,
    fill: "white"
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    cx: 985,
    cy: 155,
    r: 1,
    fill: "white"
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    cx: 356,
    cy: 141,
    r: 1,
    fill: "white"
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    cx: 977,
    cy: 486,
    r: 1,
    fill: "white"
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    cx: 715,
    cy: 276,
    r: 1,
    fill: "white"
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    cx: 329,
    cy: 583,
    r: 1,
    fill: "white"
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    cx: 688,
    cy: 580,
    r: 1,
    fill: "white"
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    cx: 621,
    cy: 113,
    r: 1,
    fill: "white"
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    cx: 409,
    cy: 416,
    r: 1,
    fill: "white"
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    cx: 991,
    cy: 206,
    r: 1,
    fill: "white"
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    cx: 362,
    cy: 192,
    r: 1,
    fill: "white"
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    cx: 983,
    cy: 537,
    r: 1,
    fill: "white"
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    cx: 721,
    cy: 327,
    r: 1,
    fill: "white"
  })), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    cx: 335,
    cy: 634,
    r: 1,
    fill: "white"
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    cx: 694,
    cy: 631,
    r: 1,
    fill: "white"
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    cx: 627,
    cy: 164,
    r: 1,
    fill: "white"
  })), _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    cx: 291,
    cy: 261,
    r: 1,
    fill: "white"
  })), _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    cx: 873,
    cy: 51,
    r: 1,
    fill: "white"
  })), _circle91 || (_circle91 = /*#__PURE__*/React.createElement("circle", {
    cx: 244,
    cy: 37,
    r: 1,
    fill: "white"
  })), _circle92 || (_circle92 = /*#__PURE__*/React.createElement("circle", {
    cx: 865,
    cy: 382,
    r: 1,
    fill: "white"
  })), _circle93 || (_circle93 = /*#__PURE__*/React.createElement("circle", {
    cx: 603,
    cy: 172,
    r: 1,
    fill: "white"
  })), _circle94 || (_circle94 = /*#__PURE__*/React.createElement("circle", {
    cx: 217,
    cy: 479,
    r: 1,
    fill: "white"
  })), _circle95 || (_circle95 = /*#__PURE__*/React.createElement("circle", {
    cx: 576,
    cy: 476,
    r: 1,
    fill: "white"
  })), _circle96 || (_circle96 = /*#__PURE__*/React.createElement("circle", {
    cx: 509,
    cy: 9,
    r: 1,
    fill: "white"
  })), _circle97 || (_circle97 = /*#__PURE__*/React.createElement("circle", {
    cx: 239,
    cy: 375,
    r: 1,
    fill: "white"
  })), _circle98 || (_circle98 = /*#__PURE__*/React.createElement("circle", {
    cx: 821,
    cy: 165,
    r: 1,
    fill: "white"
  })), _circle99 || (_circle99 = /*#__PURE__*/React.createElement("circle", {
    cx: 192,
    cy: 151,
    r: 1,
    fill: "white"
  })), _circle100 || (_circle100 = /*#__PURE__*/React.createElement("circle", {
    cx: 813,
    cy: 496,
    r: 1,
    fill: "white"
  })), _circle101 || (_circle101 = /*#__PURE__*/React.createElement("circle", {
    cx: 551,
    cy: 286,
    r: 1,
    fill: "white"
  })), _circle102 || (_circle102 = /*#__PURE__*/React.createElement("circle", {
    cx: 165,
    cy: 593,
    r: 1,
    fill: "white"
  })), _circle103 || (_circle103 = /*#__PURE__*/React.createElement("circle", {
    cx: 524,
    cy: 590,
    r: 1,
    fill: "white"
  })), _circle104 || (_circle104 = /*#__PURE__*/React.createElement("circle", {
    cx: 457,
    cy: 123,
    r: 1,
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars4);
export default __webpack_public_path__ + "static/media/stars4.37a8dc265b899c5f6acd4b65b0b5bcd6.svg";
export { ForwardRef as ReactComponent };